<template>
  <main-layout title="Usage">
    <template slot="rightElements">
      <date-picker
        v-if="selectedDateRange"
        :selectedDate="selectedDateRange"
        @changedDate="changedDate"
      />
    </template>
    <div slot="content">
      <ChartSelector
        :activeUsage="activeUsage"
        :usageData="usageData"
      />
      <UsageChartWrapper :usageData="activeUsageData" />
      <DataTableWrapper
        :activeUsage="activeUsage"
        :usageData="usageData"
      />
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/Main'
import DatePicker from '@/components/usage/DatePicker/Index'
import ChartSelector from '@/components/usage/ChartSelector/Index'
import UsageChartWrapper from '@/components/usage/UsageChart/Index'
import DataTableWrapper from '@/components/usage/DataTable/Index'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    MainLayout,
    DatePicker,
    ChartSelector,
    UsageChartWrapper,
    DataTableWrapper
  },
  computed: {
    ...mapGetters({
      selectedDateRange: 'usage/selectedDateRange',
      activeUsage: 'usage/activeUsage',
      usageData: 'usage/usageData'
    }),
    ...mapGetters({
      currentStore: 'user/getCurrentStore'
    }),
    activeUsageData () {
      return this.usageData[this.activeUsage]
    }
  },
  watch: {
    currentStore () {
      this.fetchAllUsage() // todo: move to store
    }
  },
  created () {
    if (!this.selectedDateRange) {
      this.initDateRange()
    }
  },
  methods: {
    ...mapActions('usage', ['initDateRange', 'setDateRange', 'fetchAllUsage']),
    changedDate (changedDate) {
      this.setDateRange({
        startDate: changedDate.start,
        endDate: changedDate.end
      })
    }
  }
}
</script>
